import Bloc from './Bloc.js';
import Types from './Types.js';

export default class TempShiftMana extends Bloc {

	constructor (src, ctx) {

		super("tempshiftmana", src, ctx, true);
		this.f = (src, ins) => {
			ins[0].tempShiftMana(ins[1]);
			return [];
		};
		this.types = [Types.card, Types.int];
	}
}